import { gql } from "graphql-request";

export const ADMIN_SURVEY_STATS = gql`
  query AdminSurveyStats {
    adminSurveyStats {
      totalUsers
      surveyStartedCount
      surveyCompletedCount
      writerIdentityDistribution {
        label
        count
      }
      writingFormatDistribution {
        label
        count
      }
      genreDistribution {
        label
        count
      }
      stepFunnelDistribution {
        label
        count
      }
      writingFormatByIdentity {
        writingFormat
        writerIdentity
        count
      }
    }
  }
`;

export const ADMIN_SURVEY_RESPONSES = gql`
  query AdminSurveyResponses($input: AdminSurveyResponsesInputDto!) {
    adminSurveyResponses(input: $input) {
      items {
        userId
        userEmail
        userName
        surveyCompleted
        completedAt
        lastStepReached
        writerIdentity
        writingFormat
        genreValues
        genreOtherText
        createdAt
      }
      meta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPrevPage
      }
    }
  }
`;
